// i18n area 'tasks' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.pt-PT.meta.json.
import type { enUS } from './tasks'

export const ptPT: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Operações compostas — retomáveis a partir do passo falhado, ou anuláveis',
    colType: 'Tipo',
    colTarget: 'Objeto',
    colPhase: 'Fase',
    colSteps: 'Passos',
    empty: 'Nenhuma macrotask',
    detail: 'Detalhes',
    failedAt: 'falhou em',
    resume: 'Tentar novamente a partir do passo falhado',
    abort: 'Anular tudo',
    cancel: 'Cancelar',
    actionError: 'A ação foi recusada'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Pesquisar por tipo ou target',
    type: 'Tipo',
    target: 'Target',
    phaseLabel: 'Fase',
    progress: 'Progresso',
    started: 'Iniciada',
    finished: 'Terminada',
    node: 'Nó',
    empty: 'Nenhuma task',
    loadError: 'Impossível carregar as tasks — o backend TVirt está acessível?',
    limboHint: "Nó '{node}' inacessível desde {time} — a task retém o write lease sobre o seu target até o nó voltar ou ser atestado desligado",
    nodeAttested: 'Nó atestado desligado',
    phase: {
      queued: 'Em fila',
      running: 'Em execução',
      succeeded: 'Concluída',
      failed: 'Falhada',
      cancelled: 'Cancelada',
      'failed-at-step': 'Falhada num passo',
      aborted: 'Interrompida'
    },
    dropdown: {
      tooltip: 'Tasks em curso',
      title: 'Tasks em curso',
      empty: 'Nenhuma task em curso',
      viewAll: 'Ver todas as tasks'
    },
    detail: {
      open: 'Detalhes',
      scope: 'Âmbito',
      message: 'Mensagem',
      params: 'Parâmetros',
      result: 'Resultado',
      errorTitle: 'Erro',
      steps: 'Passos',
      failedAt: 'falhou em',
      superseded: 'superada',
      step: 'Passo',
      parent: 'Task mãe',
      failedStep: 'Passo falhado',
      log: 'Log',
      logEmpty: 'Ainda nenhuma linha de log',
      close: 'Fechar'
    },
    actions: {
      cancel: 'Cancelar',
      resume: 'Tentar novamente a partir do passo falhado',
      abort: 'Anular tudo (undo dos passos concluídos)',
      refused: 'A ação foi recusada'
    }
  },
  events: {
    loadError: 'Não foi possível carregar o diário — o backend TVirt está acessível?',
    title: 'Eventos',
    subtitle: 'A memória histórica do cluster: factos consumados, do mais recente',
    filterSeverity: 'Gravidade',
    filterCategory: 'Categoria',
    filterAll: 'Todas',
    searchLabel: 'Procurar',
    searchPlaceholder: 'Pesquisar em todo o diário',
    subjectFilter: 'Eventos de {subject} — mostrar todos',
    colAt: 'Quando',
    colSeverity: 'Gravidade',
    colType: 'Tipo',
    colSubject: 'Sujeito',
    colActor: 'Quem',
    colNode: 'Nó',
    colMessage: 'Mensagem',
    empty: 'Nenhum evento',
    loadMore: 'Carregar mais',
    actorSystem: 'sistema',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID do evento',
    taskCollectedHint: 'O task tem uma retenção mais curta: se já foi recolhido a ligação não responde',
    severity: {
      info: 'Informação',
      warning: 'Aviso',
      error: 'Erro',
      critical: 'Crítico'
    },
    category: {
      lifecycle: 'Ciclo de vida',
      config: 'Configuração',
      availability: 'Disponibilidade',
      security: 'Segurança'
    },
    type: {
      haNetsvcFailedOver: 'Failover do serviço de rede',
      haNetsvcNoCandidate: 'Serviço de rede sem nó candidato',
      haNetsvcReaped: 'Instância local ceifada no regresso',
      netsvcFloatipMoved: 'IP flutuante movido para outro detentor',
      netsvcFloatipNoHolder: 'IP flutuante sem alvo saudável',
      haAppFailedOver: 'Failover da instância App',
      haAppNoCandidate: 'Instância App sem nó candidato',
      haAppStorageLocalSkip: 'Instância App não transferida: dados persistentes locais ao nó morto',
      haAppReaped: 'Pod local da instância App ceifado ao regressar'
    }
  },
  audit: {
    loadError: 'Não foi possível carregar o registo de auditoria — o backend TVirt está acessível?',
    title: 'Auditoria',
    subtitle: 'Quem fez o quê, quando e sobre que objeto — atos tentados, recusas incluídas',
    filterOutcome: 'Resultado',
    filterAll: 'Todos',
    filterSudo: 'Apenas atos elevados',
    colAt: 'Quando',
    colActor: 'Quem',
    colAction: 'Ação',
    colTarget: 'Objeto',
    colOutcome: 'Resultado',
    colNode: 'Nó',
    empty: 'Nenhum ato registado',
    loadMore: 'Carregar mais',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rota',
    detailProblem: 'Motivo',
    detailTask: 'Task',
    detailClientIp: 'De',
    detailId: 'ID do registo',
    detailSession: 'Sessão',
    taskHint: 'O resultado de um ato aceite vive no diário de eventos, sob este mesmo id de task',
    outcome: {
      succeeded: 'Bem-sucedido',
      accepted: 'Aceite',
      denied: 'Recusado',
      rejected: 'Rejeitado',
      failed: 'Falhado'
    }
  },
  notifications: {
    loadError: 'Não foi possível carregar as notificações — o backend TVirt está acessível?',
    actionError: 'A ação foi recusada',
    title: 'Notificações',
    subtitle: 'Os destinos para os quais os factos do diário saem do cluster',
    rulesTitle: 'Regras',
    rulesSubtitle: 'Que factos saem, e para onde',
    deliveriesTitle: 'Entregas',
    deliveriesSubtitle: 'O resultado de cada notificação, com o porquê quando falha',
    colName: 'Nome',
    colKind: 'Tipo',
    colWhere: 'Onde',
    colScope: 'Scope',
    colSeverity: 'Gravidade',
    colMatch: 'Filtro',
    colTargets: 'Destino',
    colAt: 'Quando',
    colState: 'Estado',
    colEvent: 'Evento',
    colAttempts: 'Tentativas',
    colOutcome: 'Resultado',
    empty: 'Nenhuma linha',
    matchAll: 'todos os factos',
    test: 'Testar',
    testOk: 'Notificação de teste entregue a {target}',
    testFailed: 'Teste para {target} falhou: {reason}',
    retry: 'Recolocar na fila',
    retried: 'Entrega recolocada na fila',
    grouped: 'e outras {count} repetições',
    state: {
      failed: 'Falhada',
      pending: 'Em fila',
      sending: 'A enviar',
      sent: 'Enviada'
    },
    tabTargets: 'Destinos',
    tabRules: 'Regras',
    tabDeliveries: 'Entregas',
    targetCreateTitle: 'Novo destino',
    ruleCreateTitle: 'Nova regra',
    nameHint: 'Minúsculas, dígitos e hífenes; único por âmbito',
    kindImmutableHint: 'Imutável: mudar o tipo significa criar outro destino',
    kindSmtp: 'Correio (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Estado',
    enabledOn: 'Ativo',
    enabledOff: 'Suspenso',
    smtpHost: 'Servidor SMTP',
    smtpPort: 'Porta',
    smtpPortHint: 'Habitual: 25 sem TLS, 587 com starttls, 465 com tls',
    smtpSecurity: 'Segurança',
    smtpFrom: 'Remetente',
    smtpTo: 'Destinatários',
    smtpToHint: 'Um ou mais endereços separados por vírgulas',
    webhookUrl: 'URL',
    payload: 'Conteúdo',
    payloadHint: 'Com minimal a mensagem e os dados do evento não saem do cluster',
    credential: 'Credencial',
    credentialNone: 'Nenhuma',
    credentialHintSmtp: 'A conta do relay do keystore; nenhuma significa SMTP anónimo',
    credentialHintWebhook: 'O segredo de assinatura do keystore; sem assinatura, quem souber o URL pode passar-se pelo cluster',
    minSeverityHint: 'Um limiar, não um conjunto: desta gravidade para cima',
    categories: 'Categorias',
    categoriesHint: 'Vazio = todas',
    types: 'Tipos de evento',
    typesHint: 'Separados por vírgulas; vazio = todos. Um tipo desconhecido é recusado',
    targetsHint: 'Pelo menos um; têm de viver no âmbito da regra ou num antecessor',
    recursiveOn: 'Também os âmbitos filhos',
    recursiveOff: 'Apenas este âmbito',
    recursiveHint: 'Os recursos vivem nas folhas: sem os filhos uma regra na raiz notifica quase nada',
    repeatWindow: 'Janela de agrupamento (s)',
    repeatWindowHint: 'Dentro da janela as repetições não enviam correio: são contadas na primeira. 0 desativa',
    targetInUseError: 'O destino {name} ainda é usado por uma regra'
  }
}
